import { assoc, compose, dissoc, map, path, prop, propOr } from 'ramda'

import replaceAllReferences from '../../../../utils/helpers/replaceAllReferences'

export const getPathWithReference = (num, list, prefix) => {
  prefix = prefix || ['categories']
  for (let index = 0; index < list.length; index++) {
    const item = list[index]
    if (item.reference === num) {
      return [...prefix, index]
    } else {
      const fullPath = getPathWithReference(num, item.children, [...prefix, index, 'children'])
      if (!!fullPath.length) {
        return fullPath
      }
    }
  }

  return []
}

export const cleanElement = value => {
  return compose(
    cleanRefs,
    dissoc('id'),
    v => (!!v.options ? assoc('options', v.options.map(dissoc('id')), v) : v),
    v => (!!v.selectedCategory ? assoc('selectedCategory', {}, v) : v),
    v => (!!v.children && !!v.children.length ? assoc('children', map(cleanElement, v.children), v) : v),
    v => (!!v.categories && !!v.categories.length ? assoc('categories', map(cleanElement, v.categories), v) : v)
  )(value)
}

export const cleanRefs = value => {
  const refs = mapRefs(value)
  return replaceAllReferences(value, refs)
}

const mapRefs = question => {
  return [
    question.reference, //
    ...(question.options || []).map(prop('reference'))
  ]
}

export const alreadyInHistory = (state = [], object) => {
  return state.history.some(item => {
    const { history, conditionsModalOpen, selectedConditionsIndex, ...restOfItem } = item
    return JSON.stringify(restOfItem) === JSON.stringify(object)
  })
}

export const historyLimit = state => {
  const MAX_HISTORY = 25
  const { history, ...restOfState } = state
  const historyLength = history.length

  const newHistoryItem = { ...restOfState, history: [], conditionsModalOpen: false, selectedConditionsIndex: null }

  if (historyLength >= MAX_HISTORY) {
    history.shift()
  }

  history.push(newHistoryItem)

  return history
}

export const countTotalChildren = (parents = []) => {
  let total = 0

  while (parents.length > 0) {
    const current = parents.pop()
    total += propOr([], 'children', current).length
    parents.push(...propOr([], 'children', current))
  }

  return total
}

export const validateAction = (state, actionType, actionsToValidate, counters) => {
  const { totalQuestions, maxQuestions } = state
  const { addAndDuplicateActions, duplicateSelectedQuestionAction, duplicateCategoryAction } = actionsToValidate
  const { dupQuestionsCount = 0, categoryQuestionsCount = 0 } = counters

  const reachedQuestionsLimit = addAndDuplicateActions.includes(actionType) && totalQuestions >= maxQuestions

  const exceedLimitOnDupQuestion =
    actionType === duplicateSelectedQuestionAction && dupQuestionsCount + totalQuestions > maxQuestions

  const exceedLimitOnDupCategory =
    actionType === duplicateCategoryAction && categoryQuestionsCount + totalQuestions > maxQuestions

  if (reachedQuestionsLimit) {
    return {
      blocked: true,
      message: 'Limite de perguntas atingido. Não é possível adicionar mais perguntas.'
    }
  }

  if (exceedLimitOnDupQuestion) {
    return {
      blocked: true,
      message: 'A pergunta não pode ser duplicada, pois excederia o limite de perguntas.'
    }
  }

  if (exceedLimitOnDupCategory) {
    return {
      blocked: true,
      message: 'A categoria não pode ser duplicada, pois excederia o limite de perguntas.'
    }
  }

  return { blocked: false }
}

export const countSelectedQuestionHierarchy = state => countTotalChildren([path(state.selectedQuestionPath)(state)]) + 1
